import { Text } from '@gasbuddy/react-components';
import { useToggle } from '@gasbuddy/react-hooks';
import { useEffect } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';
import styles from './ExpandableText.module.css';

const cx = classnames.bind(styles);

function ExpandableText({ children, onToggle, ...rest }) {
  const { t } = useTranslation('miscellaneous');
  const [expanded, toggle] = useToggle(false);

  useEffect(() => {
    onToggle(expanded);
  }, [expanded, onToggle]);

  return (
    <div {...rest}>
      <Text as="p" className={cx({ clamped: !expanded })}>{children}</Text>
      <Text as="a" bold onClick={toggle} right size="sm">
        {expanded ? t('actions.showLess') : t('actions.readMore')}
      </Text>
    </div>
  );
}

ExpandableText.propTypes = {
  children: PropTypes.node,
  onToggle: PropTypes.func,
};

ExpandableText.defaultProps = {
  children: undefined,
  onToggle: noop,
};

export default ExpandableText;
